// extracted by mini-css-extract-plugin
export default {"instruction":"NEGGnuuB7EbBJ3RNDPiU","odnwTooltipContainer":"wuvKilHtW9CwTjv7_cRC","pills":"CSNh3eUlO0pj8RGo0S4f","footer":"noV1_PQF_lUwgTqYDJS_"};